import { render, staticRenderFns } from "./tab-pane-system-message.vue?vue&type=template&id=3a12ca96&scoped=true"
import script from "./tab-pane-system-message.vue?vue&type=script&lang=js"
export * from "./tab-pane-system-message.vue?vue&type=script&lang=js"
import style0 from "./tab-pane-system-message.vue?vue&type=style&index=0&id=3a12ca96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a12ca96",
  null
  
)

export default component.exports